import _ from 'lodash'
import Backbone from 'backbone'
import template from './scoreboard-db-step3.hbs'
import formHelper from 'scoreboard/components/form-helper'
import dropdown from 'scoreboard/components/dropdown'
import licenses from 'scoreboard/components/licenses'
import locale from 'scoreboard/components/locale'
import MarkedField from 'scoreboard/components/marked-field'
import splitEvaluatorFactory from 'scoreboard/components/evaluators/split-evaluator-factory'
import hostValidator from 'scoreboard/components/validators/host-validator'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import select from 'scoreboard-select'

function domainNamesValidator(domainNames) {
	for (var i=0; domainNames != null && i < domainNames.length; i++) {
		var domainName = domainNames[i]
		if (hostValidator(domainName)) {
			return i18n.get('admin.databaseConnections.all.domainNames.invalid',
				'<q>' + domainName + '</q>')
		}
	}
}

var ScoreboardDbStep3 = Backbone.View.extend({

	tagName: 'form',

	className: 'connection-wizard',

	initialize: function(options) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.empty().append(template(this.model.attributes))
		dropdown.idLabels(this.$('[name=licenseId]'), licenses.get())
		formHelper.writeToDom(this.model, this.el)
		// supply a default license if possible
		if (!this.$('[name=licenseId]').val()) {
			this.$('[name=licenseId]').val(_.result(licenses, '[0].id'))
		}
		// #10921 if no license defined for existing db, start with blank selection
		if (_.isUndefined(this.model.get('licenseId')) && !this.model.isNew()) {
			this.$('[name=licenseId]').val('')
		}

		// choose a default option for the languageCode
		var l = locale()
		//default to use just the language as the value
		var languageCode = l.language
		// Only if Chinese/Taiwanese is the language/country, then we use the entire locale string
		if (l.locale === 'zh_tw') {
			languageCode = l.locale
		}
		this.$('[name=languageCode]').val(languageCode)

		this.domainNamesField = new MarkedField({
			el: this.$('[name=domainNames]'),
			evaluator: splitEvaluatorFactory(','),
			validator: domainNamesValidator
		}).render()

		this.options.wizard.render({
			formView: this.formView,
			doneKey: function() {
				return this.model.isNew() ? 'common.add' : 'common.save'
			}.bind(this)
		})

		this.formView.start()

		select(this.el.querySelectorAll('select'))
		return this
	},

	saveState: function() {
		this.model.set(formHelper.readFromDom(this.el))
	},

	back: function(options) {
		this.saveState()
		this.options.wizard.back({
			model: this.model,
			message: options.message
		})
	},

	submit: function(e) {
		e.preventDefault()

		this.$('.back').prop('disabled', true)

		this.model.set(formHelper.readFromDom(this.el))

		this.options.wizard.finish()
		this.options.wizard.once('done', this.trigger.bind(this, 'done'))
		this.options.wizard.once('connection-error', this.back.bind(this))
		this.options.wizard.once('error', this.formView.start.bind(this.formView))
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.domainNamesField, this.formView, this.wizardProgress], 'remove')
	}


})

export default ScoreboardDbStep3

ScoreboardDbStep3.__filename__ = 'admin/connections/scoreboard-db-step3.js'
